import React from "react";
import colors from "stylesheets/utilities/colors.scss";
import QuestionAskedImage from "./images/Year-in-number-Questionsasked.png";
import AnswerBuiltImage from "./images/Year-in-number-Answer-built.png";
import ThumbsUpImage from "./images/Year-in-number-thumbs-up.png";
import AgentHoursImage from "./images/Year-in-number-Agent-hours.png";

export const metricModalStyles = [
  {
    image: {
      src: QuestionAskedImage,
      top: 153,
      right: 50,
      width: 231,
      height: 240
    },
    text: {
      title: "This year chatters asked",
      description: <span>questions&hellip;</span>,
      top: 154
    },
    circle: {
      color: colors.colorAnalyticsModernPurple,
      diameter: 506,
      top: -149,
      right: -182
    },
    value: {
      top: 154 + 30,
      nextTop: 144 + 30
    }
  },
  {
    image: {
      src: AnswerBuiltImage,
      top: 96,
      right: 28,
      width: 268,
      height: 242
    },
    text: {
      title: "You built",
      description: <span>answers to respond to those questions&hellip;</span>,
      top: 144
    },
    circle: {
      color: colors.colorAnalyticsForestGreen,
      diameter: 431,
      top: -55,
      right: -173
    },
    value: {
      top: 144 + 30,
      nextTop: 228 + 30
    }
  },
  {
    image: {
      src: ThumbsUpImage,
      top: 54,
      right: -44,
      width: 324,
      height: 279
    },
    text: {
      title: "Your chatters gave",
      description: "thumbs up to the answers they loved",
      top: 228
    },
    circle: {
      color: colors.colorAnalyticsLightPink,
      diameter: 576,
      top: -264,
      right: -208
    },
    value: {
      top: 228 + 30,
      nextTop: 144 + 30
    }
  },
  {
    image: {
      src: AgentHoursImage,
      top: 56,
      right: 64,
      width: 203,
      height: 343
    },
    text: {
      title: "And that saved",
      description: "agent hours*",
      top: 144
    },
    circle: {
      color: colors.colorAnalyticsModernPurple,
      diameter: 500,
      top: -124,
      right: -180
    },
    value: {
      top: 144 + 30,
      nextTop: 144 + 30
    }
  },
  {
    circle: {
      color: colors.colorAnalyticsLightPink,
      diameter: 226,
      top: 60,
      right: 187
    },
    backgroundColor: colors.colorAnalyticsDarkBlue
  }
];

export const wrapUpReportRequestParams = {
  filter: {
    dataType: "year_end_2019",
    startDate: "2019-01-01",
    endDate: "2019-12-31"
  }
};
